"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
/* eslint-disable */
var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "38",
    height: "38",
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 37.9998C29.4934 37.9998 38 29.4932 38 18.9998C38 8.50635 29.4934 -0.000244141 19 -0.000244141C8.50659 -0.000244141 0 8.50635 0 18.9998C0 29.4932 8.50659 37.9998 19 37.9998Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: "0.2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0416 15.0415C34.0416 25.5349 25.535 34.0415 15.0416 34.0415C10.8045 34.0415 6.89142 32.6546 3.73145 30.3099C7.19346 34.9759 12.7436 37.9998 18.9999 37.9998C29.4933 37.9998 37.9999 29.4932 37.9999 18.9998C37.9999 12.7434 34.976 7.19334 30.3101 3.73132C32.6547 6.8913 34.0416 10.8044 34.0416 15.0415Z",
    fill: "#E87474"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.7291 26.9164H12.2708V29.2914H25.7291V26.9164Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.2292 16.7902L5.63002 12.2706L4.75 14.933L8.95601 16.4396C8.21834 16.9201 7.68774 17.7123 7.68774 18.6734C7.68774 20.167 8.8913 21.3748 10.3796 21.3748C11.8679 21.3748 13.0714 20.167 13.0714 18.6734C13.0714 18.3877 12.9938 18.115 12.9032 17.8552L15.2068 18.6734L16.2292 16.7902Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.7708 16.7902L32.37 12.2706L33.25 14.933L29.044 16.4396C29.7817 16.9201 30.3123 17.7123 30.3123 18.6734C30.3123 20.167 29.1087 21.3748 27.6204 21.3748C26.1321 21.3748 24.9286 20.167 24.9286 18.6734C24.9286 18.3877 25.0062 18.115 25.0968 17.8552L22.7932 18.6734L21.7708 16.7902Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "19.0018",
    y1: "37.9943",
    x2: "19.0018",
    y2: "-0.00206501",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.2719",
    stopColor: "#FFDE63"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.8509",
    stopColor: "#E25D5D"
  }))));
};
exports.default = _default;